import { render } from "./ComplianceApproval.vue?vue&type=template&id=76e032c4"
import script from "./ComplianceApproval.vue?vue&type=script&lang=js"
export * from "./ComplianceApproval.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__